// extracted by mini-css-extract-plugin
export default {"icon":"option_icon__553vS"};